var template = require('./templates/drawing.hbs');

module.exports = Backbone.View.extend({
  buttons: [
    {
      tag: 'editor.square',
      mode: 'square',
      icon: 'desygner-icon-square'
    },
    {
      tag: 'editor.line',
      mode: 'line',
      icon: 'desygner-icon-line'
    },
    {
      tag: 'editor.circle',
      mode: 'circle',
      icon: 'desygner-icon-fill'
    },
    {
      tag: 'editor.pen',
      mode: 'fhpath',
      icon: 'desygner-icon-drawing'
    },
    {
      tag: 'editor.rectangle',
      mode: 'rect',
      icon: 'desygner-icon-rectangle'
    },
    {
      tag: 'editor.ellipse',
      mode: 'ellipse',
      icon: 'desygner-icon-elipse'
    },
    {
      tag: 'editor.path',
      mode: 'path',
      icon: 'fa fa-bookmark'
    }
  ],

  initialize: function () {
    _.bindAll(this, 'changeModeEvent', 'render');

    this.editor = INKIVE.Tool.getInstance().editor;
    this.$el.closest('a').one('mousedown', this.render);
  },

  changeModeEvent: function (event) {
    var mode = $(event.currentTarget).data('mode');
    $('#workarea').css('cursor', 'crosshair');
    this.editor.clearSelection();
    this.editor.setMode(mode);
  },

  render: function () {
    this.$el.html(template(this.buttons));
    this.$el.find('.drawing-tool').on('click', this.changeModeEvent);
  }
});
